import { createFileRoute } from '@tanstack/react-router';

import { StudioPage } from '~/features/setup-studio/studio-page';

/** Setup: the studio on a session the server holds, or the one-page form when the server holds no model key. */
export const Route = createFileRoute('/onboarding/')({
  component: StudioPage,
});
